import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg transition-all duration-300 hover:bg-secondary"
      aria-label="Toggle theme"
    >
      <div className="relative w-6 h-6">
        <div className="absolute inset-0 transition-opacity duration-300"
          style={{ opacity: theme === 'dark' ? 1 : 0 }}>
          <Sun className="w-6 h-6 text-yellow-400 transition-transform duration-300" />
          <div className="absolute inset-0 bg-yellow-400/20 blur-xl rounded-full animate-pulse" />
        </div>
        <div className="absolute inset-0 transition-opacity duration-300"
          style={{ opacity: theme === 'light' ? 1 : 0 }}>
          <Moon className="w-6 h-6 text-blue-400 transition-transform duration-300" />
          <div className="absolute inset-0 bg-blue-400/20 blur-xl rounded-full animate-pulse" />
        </div>
      </div>
    </button>
  );
}